import { formatDateLong } from '../utils';

function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

export function buildCertificateHtml({
  userName,
  moduleTitle,
  certificateId,
  completedAt,
  score,
}) {
  const safeName = escapeHtml(userName || 'Staff Member');
  const safeModule = escapeHtml(moduleTitle || 'In-Service Training');
  const safeCert = escapeHtml(certificateId || '');
  const safeDate = escapeHtml(formatDateLong(completedAt));
  const safeScore = escapeHtml(score != null ? `${score}%` : '');

  return `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="utf-8" />
<title>Certificate – ${safeModule}</title>
<style>
  body {
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
    background: #F1ECF7;
    margin: 0;
    padding: 40px 20px;
    color: #1B2A4A;
  }
  .cert {
    background: #FFFDF5;
    max-width: 880px;
    margin: 0 auto;
    padding: 60px 70px;
    border: 12px solid #6B4C9A;
    box-shadow: 0 12px 30px rgba(0,0,0,0.08);
    position: relative;
  }
  .cert::after {
    content: "";
    position: absolute;
    inset: 10px;
    border: 2px solid #C9A84C;
    pointer-events: none;
  }
  .brand {
    text-align: center;
    color: #6B4C9A;
    font-weight: 700;
    font-size: 18px;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
  h1 {
    text-align: center;
    margin: 24px 0 12px;
    font-size: 42px;
    color: #533879;
    letter-spacing: 2px;
  }
  .subtitle {
    text-align: center;
    color: #6B7280;
    margin-bottom: 36px;
    font-size: 16px;
  }
  .awarded {
    text-align: center;
    font-size: 14px;
    color: #374151;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin-bottom: 12px;
  }
  .name {
    text-align: center;
    font-size: 36px;
    font-weight: 700;
    color: #533879;
    border-bottom: 2px solid #C9A84C;
    padding-bottom: 12px;
    margin: 0 auto 28px;
    max-width: 600px;
  }
  .for {
    text-align: center;
    color: #374151;
    font-size: 16px;
    margin-bottom: 8px;
  }
  .module {
    text-align: center;
    font-size: 22px;
    font-weight: 700;
    color: #1B2A4A;
    margin-bottom: 28px;
  }
  .meta {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    margin-top: 48px;
    border-top: 1px solid #D1D5DB;
    padding-top: 20px;
    font-size: 13px;
    color: #6B7280;
  }
  .meta strong { color: #1B2A4A; display: block; font-size: 14px; }
  .cert-id {
    font-family: ui-monospace, "SF Mono", Menlo, monospace;
    color: #6B4C9A;
    font-weight: 700;
  }
  @media print {
    body { background: white; padding: 0; }
    .cert { box-shadow: none; }
  }
</style>
</head>
<body>
  <div class="cert">
    <div class="brand">NurturingNurses&reg; HomeCare</div>
    <h1>Certificate of Completion</h1>
    <div class="subtitle">Staff In-Service Training</div>

    <div class="awarded">This certificate is awarded to</div>
    <div class="name">${safeName}</div>

    <div class="for">for successfully completing</div>
    <div class="module">${safeModule}</div>

    <div class="meta">
      <div>
        <strong>Date Completed</strong>
        ${safeDate}
      </div>
      <div>
        <strong>Score</strong>
        ${safeScore}
      </div>
      <div>
        <strong>Certificate ID</strong>
        <span class="cert-id">${safeCert}</span>
      </div>
    </div>
  </div>
</body>
</html>`;
}

export function downloadCertificate(data) {
  const html = buildCertificateHtml(data);
  const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const safeId = (data.certificateId || 'certificate').replace(/[^A-Za-z0-9-]/g, '_');
  const a = document.createElement('a');
  a.href = url;
  a.download = `${safeId}.html`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
